import { map } from 'underscore';

export const parseDateFromAPIFormat = (i18n, date) => {
  if (date == null) {
    return null;
  }
  if (typeof date === 'string') {
    const dateFromMdyyyyFormat = i18n.parseDate(date.substring(0, 10), { raw: 'M/d/yyyy' });
    const dateFromyyyyMdFormat = i18n.parseDate(date.substring(0, 10), { raw: 'yyyy-M-d' });
    return dateFromMdyyyyFormat || dateFromyyyyMdFormat;
  }
  return date;
};

export const formatDateToAPIFormat = (i18n, date) => {
  if (date == null) {
    return '';
  }

  if (typeof date === 'string') {
    return date;
  }
  return i18n.formatDate(date, {
    raw: 'M/d/yyyy',
  });
};

const EntityNegativeReferenceId = -111;

export const getTargetCriterion = ({
  targets,
  type,
  propKey,
  adGroupViewModel,
  campaignViewModel,
  bidAdjustment,
  overrideType = undefined,
  level = 'campaign',
}) => targets.map((target) => {
  let BidAdjustment = bidAdjustment;
  let propValue = target.criterion;

  if (typeof (target.criterion) === 'object') {
    propValue = target.criterion.Target;

    if (bidAdjustment === undefined) {
      const { BidAdjustment: bid } = target.criterion;
      BidAdjustment = bid;
    }
  }

  const criterion = {
    Type: overrideType || type,
    BidAdjustment,
    [`${overrideType || type}Criterion`]: {
      [propKey]: propValue,
    },
  };

  if (level === 'campaign') {
    return {
      Id: target.Id,
      Status: target.status ? target.status : 'Active',
      Criterion: criterion,
      CriterionType: type,
      Campaign: {
        Id: campaignViewModel.Id || EntityNegativeReferenceId,
      },
    };
  }

  return {
    Id: target.Id,
    Status: target.status ? target.status : 'Active',
    Criterion: criterion,
    CriterionType: type,
    AdGroup: {
      Id: adGroupViewModel.Id || EntityNegativeReferenceId,
    },
    // CampaignName: campaignViewModel.Name,
  };
});

export const flattenTargetCriterion = (targetsWithBidAdjustment, type) => map(targetsWithBidAdjustment, (target) => {
  const {
    Id,
    Criterion: {
      BidAdjustment,
      [`${type}Criterion`]: {
        Target,
      } = {},
    } = {},
  } = target;

  return {
    Id,
    BidAdjustment,
    criterion: Target,
  };
});

export const hydrateCriterionWithBidAndId = (criterionType, initialTargetList, adddedCriterionList, targetWithBidAdjustmentList = []) => {
  for (let i = 0; i < adddedCriterionList.length; i += 1) {
    const criterion = adddedCriterionList[i];

    // add bid adjustments to modified criterion
    const matchingTargetWithBid = targetWithBidAdjustmentList.find(criterionWithBidAdjustment =>
      criterionWithBidAdjustment.Criterion[`${criterionType}Criterion`].Target === criterion.Criterion[`${criterionType}Criterion`].Target);
    if (matchingTargetWithBid) {
      criterion.Criterion.BidAdjustment = matchingTargetWithBid.Criterion.BidAdjustment;
    }

    // add id to update existing criterion in MT
    const originalCrition = initialTargetList.find(initialTarget => (initialTarget.criterion || initialTarget.Target) === criterion.Criterion[`${criterionType}Criterion`].Target);
    if (originalCrition) {
      criterion.Id = originalCrition.Id;
    }
  }
};
